<div class="flex flex-row grow h-screen items-start">
  <!-- Left panel -->
  <div class="login-panel flex flex-col basis-1/2 gap-20 px-40 pt-40 pb-5 h-full">
    <div class="p-4 flex flex-col gap-20">
      <div>
        <div class="heading-lg">Welcome</div>
        <div class="text-base">Sign in to access your classroom and device management tools</div>
      </div>

      <div class="flex flex-col gap-3">
        <div class="flex gap-1">
          <lib-cdw-icon class="login-warning" icon="warning"></lib-cdw-icon>
          <span>Please be sure to sign in with the correct Google profile.</span>
        </div>
        <cdw-ae-google-login-button (click)="handleGoogleLogin()" class="w-full"></cdw-ae-google-login-button>
        <div *ngIf="isLoading" class="text-sm text-gray-600">Logging in...</div>
        <div *ngIf="loginError" class="flex items-start gap-2 mt-4 p-3 bg-red-50 border border-red-200 rounded">
          <lib-cdw-icon icon="warning" size="20px" [customColor]="'#dc2626'"></lib-cdw-icon>
          <span class="text-sm text-red-700">{{ loginError }}</span>
        </div>
      </div>

      <div class="flex flex-col gap-3">
        <div>
          <a [href]="helpCenterUrl" target="_blank">
            Having trouble signing in?
          </a>
        </div>
        <div class="text-base">
          Don't have an account? <a [href]="helpCenterUrl" target="_blank">See here</a> for
          information on how to get one.
        </div>
      </div>
    </div>

    <div class="footer-panel flex flex-row items-center gap-5 mt-auto">
      <div><img src="images/cdwlogo_tmp.png" width="84px" /></div>
      <div class="flex flex-col">
        <div>By signing in, you agree to our</div>
        <div>
          <a
            class="!text-[14px]"
            [href]="privacyUrl"
            target="_blank"
            >Privacy Policy</a
          >
        </div>
      </div>
    </div>
  </div>

  <!-- Right panel -->
  <div class="marketing-panel flex flex-col basis-1/2 gap-32 px-28 pt-44 h-full">
    <div class="flex flex-col gap-4">
      <div class="statistic-number">29.3 million</div>
      <div class="achievement-text">active Chromebook devices managed by Gopher for Chrome Premium</div>
    </div>

    <div class="flex flex-col gap-4 pl-10">
      <div class="statistic-number">2023</div>
      <div class="achievement-text">Google Cloud Specialization</div>
      <div class="achievement-text">Partner of the Year - Education</div>
    </div>
  </div>
</div>
